import {
  CLEAR_REGISTERED_USERS_COUNT,
  GET_REGISTERED_ALL_COUNT_SUCCESS,
  GET_REGISTERED_PERSONS_COUNT_SUCCESS,
} from '../actionConstants';

const defaultState = null;

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_REGISTERED_PERSONS_COUNT_SUCCESS:
    case GET_REGISTERED_ALL_COUNT_SUCCESS:
      return action.res.data;
    case CLEAR_REGISTERED_USERS_COUNT:
      return defaultState;
    default:
      return state;
  }
};
